/**
 * Route for `igaming-geographic-jurisdiction-block-geo-exclusio`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingGeographicJurisdictionBlockGeoExclusioPage } from "../features/igaming-geographic-jurisdiction-block-geo-exclusio/IgamingGeographicJurisdictionBlockGeoExclusioPage";

export const igamingGeographicJurisdictionBlockGeoExclusioRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-geographic-jurisdiction-block-geo-exclusio",
	component: IgamingGeographicJurisdictionBlockGeoExclusioPage,
});

export default igamingGeographicJurisdictionBlockGeoExclusioRoute;
